var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 24,
    viewBox: "0 0 154 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.177 16.4292H10.4425L7.89381 12.0044L10.4425 7.61506H12.2832L10.2301 4.25223L12.2832 0.854004H6.44248L0 12.0044L6.44248 23.1903H12.3186L14.3009 19.8629L12.177 16.4292Z",
    fill: "#FB263B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.8053 12.0044L19.3628 0.854004H13.7345L11.6814 4.25223L13.7345 7.61506H15.5044L18.0531 12.0044L15.5044 16.4292H13.6637L15.7522 19.8629L13.7699 23.1903H19.3628L25.8053 12.0044Z",
    fill: "#BDBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.7256 0.854004H38.8318V16.0044H45.6283V23.1549H30.7256V0.854004Z",
    fill: "#FB263B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.4956 7.82743C63.0797 7.82743 64.6726 9.80973 64.6726 12.1814C64.6726 14.7301 62.9735 16.4646 60.4956 16.4646C58.0531 16.4646 56.3186 14.7301 56.3186 12.1814C56.3186 9.80973 57.9115 7.82743 60.4956 7.82743ZM60.4956 0.5C53.7345 0.5 48.177 5.06637 48.177 12.0752C48.177 19.2257 53.6991 23.5088 60.4956 23.5088C67.2921 23.5088 72.8142 19.2257 72.8142 12.0752C72.8142 5.06637 67.2567 0.5 60.4956 0.5Z",
    fill: "#FB263B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M96.3186 0.854004L89.3452 11.2965L97.3098 23.1549H88.0708L85.5222 18.4115C85.2744 17.9513 85.1328 17.5266 85.062 17.0664H84.8142C84.6726 17.5974 84.4602 18.0929 84.177 18.5885L81.6991 23.1549H72.4602L80.2832 11.2965L73.2744 0.854004H82.4071L84.0708 4.00445C84.3894 4.60622 84.5664 5.20798 84.7434 5.84515H84.9204C85.062 5.20798 85.3452 4.60622 85.6284 4.00445L87.1505 0.854004H96.3186Z",
    fill: "#FB263B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M108.637 15.0841L110.124 8.28763H110.407C110.549 9.24339 110.69 10.1991 110.938 11.1549L111.894 15.0841H108.637ZM107.186 20.3938H113.31L114.053 23.1903H122.62L114.655 0.889404H105.699L97.947 23.1903H106.513L107.186 20.3938Z",
    fill: "#FB263B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M127.009 0.854004H135.363L138.442 12.5708H138.655C138.796 11.5797 138.938 10.5531 139.221 9.59737L141.734 0.854004H149.982L153.664 23.1549H145.841L144.743 10.9425H144.602C144.46 11.6859 144.319 12.4646 144.071 13.1726L140.85 23.1549H136.106L133.204 13.7036C132.956 12.7478 132.743 11.8629 132.708 10.9071H132.425C132.354 11.7921 132.319 12.7124 132.212 13.5974L131.257 23.1195H123.434L127.009 0.854004Z",
    fill: "#FB263B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42bd3a6d53a3c35600470cbfb8b2d7a0.svg";
export { ForwardRef as ReactComponent };